import { Box, Button, Typography } from "@mui/material"
import { exportTanClientForm, exportTracesclientDemand, getClientDemand, getClientForm, getIncomeTaxProfile } from "api/services/automation/income-tax-tan";
import Table from "components/Table";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { StyledSpan } from "../../styles";
import { useState } from "react";
import AccessDenied from "../../Access/accessDenide";
import Loader from "components/Loader";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { getCurrentFormattedDateTime } from "utils";
import { SortDirection } from "data/constants";
import _ from "lodash";
import sortHandler from "components/Table/SortHandler";
import { formattedAmount } from "utils/formattedAmount";


const TraceClientDemand = (state) => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate()
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [checkAccess, setCheckAccess] = useState(true)
    let defaultColumns = [
        {
            key: "financialYear",
            title: "Financial Year",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
            render: (row: any) => {
                return (
                    <Box>
                        <Typography>{row?.financialYear ? row?.financialYear : "-"}</Typography>

                    </Box>
                )
            },
        },
        {
            key: "quarter",
            title: "Financial Quarter",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "formType",
            title: "Form Name",
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
        {
            key: "netPayableAmount",
            title: "Net Payable (Rounded-Off)",
            render:(v:any)=>(
                <Typography>{v?.netPayableAmount ? formattedAmount(v?.netPayableAmount) : "-"}</Typography>
            ),
            sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
        },
    ];
  const [sort, setSort] = useState<any>({});
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));
    const { data, isLoading }: ResType = useQuery(
        ["get-demand-data-trace", params.incometaxid, { limit: pageCount, offset: page * pageCount,sort }],
        getClientDemand,
        {
            onSuccess: (res) => {
                console.log(res)
                setCheckAccess(res?.data?.accessDenied)
                setTotalCount(res?.data?.count);
            },
        }
    );


    const { data: clientData, isLoading: isLoading1 }: ResType = useQuery(
        ["get-income-tax-tan-profile", params.incometaxid],
        getIncomeTaxProfile,
    );
    const clientName = clientData?.data?.profileDetails?.name;

    const { mutate: mutate1 } = useMutation(exportTracesclientDemand, {
        onSuccess: (res: any) => {
            const arr = new Uint8Array(res.data?.data);
            const blob = new Blob([arr], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const file = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            const formattedDateTime = getCurrentFormattedDateTime();
            link.href = file;
            link.download = `ATOM Pro - ${clientName} Income Tax (Traces) Demands ${formattedDateTime}.xlsx`;
            link.click();
            snack.success("Income Tax Demands exported successfully");
        },
        onError: (err: any) => {
            snack.error(err);
            snack.error(handleError(err));
        },
    });
    const handleExport = () => {
        mutate1({
            ...state,
            incometaxid: params.incometaxid
        });
    };


    const handleSort = (v: any) => {
        sortHandler({
          key: v.key,
          columns,
          sortState: sort,
          setSortState: setSort,
          setColumns: setColumns,
        });
      };
    const handleRowClick = (v: any) => {
        navigate(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/demand/${v?.id}`)
    }

    if (isLoading) return <Loader />
    return (
        <>
            <Box display="flex" justifyContent="flex-end" m={2}>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleExport}
                    startIcon={<FileDownloadOutlinedIcon />}
                >
                    Export
                </Button>
            </Box>
            <Box pl={1} pr={1}>
                {!checkAccess && (
                    <AccessDenied />
                )}

                {checkAccess && (
                    <Box>
                        {data && data?.data.count > 0 ?
                            <>
                                <Table
                                    sx={{ height: '460px' }}
                                    // selection={{ selected, setSelected }}
                                    pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
                                    data={data?.data?.result || []}
                                    columns={columns}
                                    sortHandler={handleSort}
                                    loading={isLoading}
                                    onRowClick={handleRowClick}
                                />
                            </> : <>
                                <Box textAlign="center" mt={20}>
                                    <Typography variant="subtitle1" color="rgba(0,0,0,0.5)">
                                        No Data present
                                    </Typography>
                                </Box>
                            </>}
                    </Box>
                )}
            </Box>
        </>
    )
}

export default TraceClientDemand;